import {get, post} from '@/api/clients';
import {MapService} from '@/models/dto/map/map-service';

const MNGT_MAP_SERVICE_API_BASE = '/mngt/mapServices';

/**
 * (GET) MapService 키변환 안한채로 조회
 * @returns MapServiceDTO 배열
 * @author mark
 */
export const fetchMapServicesNotConverted = async (): Promise<MapService[]> => {
  return await get<MapService[]>(MNGT_MAP_SERVICE_API_BASE);
};

/**
 * (POST) MapService 생성
 * @param newService
 * @returns
 * @author mark
 */
export const createMapService = async (newService: MapService): Promise<MapService> => {
  return await post<MapService>(`${MNGT_MAP_SERVICE_API_BASE}`, newService);
};

/**
 * (POST) MapService 업데이트
 * @param id
 * @param updatedService
 * @returns
 * @author mark
 */
export const updateMapService = async (id: number, updatedService: MapService): Promise<MapService> => {
  return await post<MapService>(`${MNGT_MAP_SERVICE_API_BASE}/${id}`, updatedService);
};

/**
 * (POST) MapService 삭제
 * @param ids MapService id 배열
 * @returns
 * @author mark
 */
export const deleteMapServices = async (ids: number[]) => {
  return await post<MapService>(`${MNGT_MAP_SERVICE_API_BASE}/delete`, {ids});
};

/**
 * (POST) MapService 순서 변경
 * @param ordered
 * @returns
 * @author mark
 */
export const updateMapServiceOrder = async (ordered: {id: number; ordr: number}[]) => {
  return await post<MapService>(`${MNGT_MAP_SERVICE_API_BASE}/order`, ordered);
};
